import { AuthData, AuthStatus } from "../models/auth-status";
import { marker as _ } from "@colsen1991/ngx-translate-extract-marker";

const tabs = [
    { icon: 'home', label: _('footer.HOME'), path: '/home', disabled: false},
    { icon: 'challenge', label: _('footer.CHALLENGE'), path: '/challenges', disabled: false, condition: (authData: AuthData) => {
            return authData.data.challenges_active || false;
        }},
    { icon: 'feedback', label: _('footer.FEEDBACK'), path: '/feedbacks', disabled: false},
    { icon: 'badge', label: _('footer.BADGE'), path: '/badge', disabled: false},
    { icon: 'user', label: _('footer.PROFILE'), path: '/profile', disabled: false},
];

export const filteredTab = (status: AuthStatus) => {
    tabs.forEach(tab => {
        if (status.restricted && tab.path !== '/badge') {
            tab.disabled = true;
        }
    });
    return tabs.filter(tab => tab.condition ? tab.condition(status.authData) : true);
}